import { APIDataDepartment, APIMetaDataDepartmentPropertyNames } from '@evertel/types'
import { Store } from '@evertel/types'
import { decorate, injectable } from '@evertel/di'

export interface APIDataDepartmentOptions {
    integrationsEnabled?: boolean
}

export interface APIDataDepartmentExtended extends Omit<APIDataDepartment, 'options'> {
    options?: APIDataDepartmentOptions
}

class DepartmentStore extends Store<APIDataDepartmentExtended> {
    private _inflightFetches = new Map<number, Promise<unknown>>()

    constructor() {
        super([...APIMetaDataDepartmentPropertyNames, 'publicMedia', 'enterprise'])
    }

    getInflightFetch(departmentId: number) {
        return this._inflightFetches.get(departmentId)
    }

    setInflightFetch(departmentId: number, promise: Promise<unknown>) {
        this._inflightFetches.set(departmentId, promise)
    }

    clearInflightFetch(departmentId: number) {
        this._inflightFetches.delete(departmentId)
    }
}

decorate(injectable(), DepartmentStore)

export { DepartmentStore }
